/**
 * @title Kontiki JS / Socket
 * @description Sockets for Kontiki JS.
 *
 * @author Daniel K. Hendricks
 * @license MIT (Please read the attached license in root)
 * @copyright (c) 2021-present, Daniel K. Hendricks
 *
 * @see https://kontikijs.org
 * @support https://kontikijs.com
 */

import { Plugin } from 'vite'
import { ServerConfigExport } from './server/types'
import framework from './server/utils/js-framework'
import configuredServer from './server/utils/configure-server'
import transformedHtml from './server/utils/transform-index-html'
import client from './client'

const virtualFileId = '@io'
const clientPlugin = client(framework())

export const socket = (config?: Partial<ServerConfigExport>): Plugin => {
  return {
    name: 'kontiki:socket',
    configureServer(param) { return configuredServer(param, config) },
    transformIndexHtml(html) { return transformedHtml(html) },
    resolveId(id) {
      if (id === virtualFileId) {
        return virtualFileId
      }
    },
    load(id) {
      if (id === virtualFileId) {
        return `export default {${clientPlugin}}`
      }
    }
  }
}

